var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDropDownArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sort-Alphabet-Ascending-path Copy 3",
    d: "M11.2808 21.4252C10.9637 21.7892 10.495 22 9.99998 22C9.505 22 9.03627 21.7892 8.71919 21.4248L0.386157 11.8248C-0.202989 11.1452 -0.107159 10.1356 0.599482 9.57C1.30904 9.0044 2.35734 9.0964 2.94815 9.7748L8.33337 15.98V1.6C8.33337 0.7156 9.07876 0 9.99998 0C10.9212 0 11.6666 0.7156 11.6666 1.6V15.98L17.0522 9.7752C17.6414 9.0972 18.6913 9.0048 19.4009 9.5704C20.1071 10.136 20.203 11.1452 19.6138 11.8252L11.2808 21.4252Z",
    fill: "currentcolor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDropDownArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dropDownArrow.46eb55d46e272326730fcf4e358f9ebc.svg";